import LeadsActions from './LeadsActions.component';

export default LeadsActions;